<div class="scanner-container">
  <div class="scanner-header">
    <h2>Escaneo de ubicaciones</h2>
  </div>

  <div class="scanner-content">
    <div class="cameras-grid">
      <button
        (click)="selectCamera(camera)"
        *ngFor="let camera of cameras"
        [class.active]="camera.id === activeCameraId"
        class="camera-button"
        mat-raised-button
      >
        <div class="camera-icon">{{ camera.humanLabel.split(" ")[0] }}</div>
        <span>{{ camera.humanLabel.split(" ").slice(1).join(" ") }}</span>
      </button>
    </div>

    <div class="scanner-wrapper">
      <ngx-scanner-qrcode
        #action="scanner"
        [config]="scannerConfig"
        class="scanner-qr"
      >
      </ngx-scanner-qrcode>

      <button
        *ngIf="retryButton"
        class="retryButton accept-btn"
        (click)="activateCameras()"
        mat-raised-button
      >
        <mat-spinner
          *ngIf="retryingCameras"
          class="loading"
          diameter="20"
        ></mat-spinner>
        <mat-icon *ngIf="!retryingCameras" class="success"
          >check_circle</mat-icon
        >
        <span>Activar Camaras</span>
      </button>

      <div
        *ngIf="status"
        [class.error]="currentStatus.type === 'error'"
        [class.loading]="currentStatus.type === 'loading'"
        [class.success]="currentStatus.type === 'success'"
        class="status-message"
      >
        <mat-spinner
          *ngIf="currentStatus.type === 'loading'"
          diameter="20"
        ></mat-spinner>
        <mat-icon *ngIf="currentStatus.type === 'error'"
          >error_outline</mat-icon
        >
        <mat-icon *ngIf="currentStatus.type === 'success'"
          >check_circle</mat-icon
        >
        <span>{{ currentStatus.message }}</span>
      </div>
    </div>

    <mat-accordion class="locations-list">
      <mat-expansion-panel
        *ngFor="let ubicacion of bultosPorUbicacion | keyvalue"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="location-header">
              <span class="location-name">{{ ubicacion.key }}</span>
              <mat-icon
                [class.scanned]="
                  ubicacion.value.escaneada ||
                  verificarTodasLasUbicacionesCheckeadas(ubicacion.value)
                "
              >
                check_circle
              </mat-icon>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="bultos-list">
          <mat-card
            *ngFor="let bulto of ubicacion.value.bultos"
            class="bulto-card"
          >
            <mat-card-content>
              <div class="bulto-info">
                <mat-icon>inventory_2</mat-icon>
                <div class="bulto-details">
                  <span style="display: flex; gap: 16px">
                    <p class="bulto-id">
                      {{ bulto.id }}
                    </p>
                    <mat-spinner
                      *ngIf="bulto.enCola"
                      diameter="20"
                      color="primary"
                    ></mat-spinner>
                  </span>
                  <p class="bulto-desc">{{ bulto.descripcion }}</p>
                  <p *ngIf="bulto.nunidades" class="bulto-units">
                    Unidades: {{ bulto.nunidades }}
                  </p>
                </div>
                <mat-checkbox
                  (change)="verificarEntrega(bulto)"
                  [(ngModel)]="bulto.isChecked"
                  color="primary"
                >
                </mat-checkbox>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="action-buttons">
    <button
      (click)="cancel()"
      [disabled]="lockUserInteraction"
      class="cancel-btn"
      mat-stroked-button
    >
      <mat-icon>close</mat-icon>
      <span>Cancelar</span>
    </button>

    <button
      (click)="continueToDelivery()"
      [disabled]="!permiteEntrega || lockUserInteraction"
      class="continue-btn"
      color="primary"
      mat-raised-button
    >
      <mat-icon>check</mat-icon>
      <span>Continuar entrega</span>
    </button>
  </div>
</div>
